module.exports = __webpack_public_path__ + "img/视频封面15.e778b2fb.png";